module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__chile_White.bcf81c6f.svg";